import { BackOutlineIcon, ForwardOutlineIcon } from '@carboncopyco/icons';
import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { Button, TooltipBubble } from '@carboncopyco/ui';
import { useNavigation } from '../../../hooks/useNavigation';

export const NavigationBar = ({
  tab,
  textColor = 'text-ds-black',
}: {
  tab: IGlobalTab;
  textColor?: string;
}) => {
  const { canGoBack, canGoForward, goForward, goBack } = useNavigation(tab);

  return (
    <div className={`flex width-90 align-center justify-between ${textColor}`}>
      <TooltipBubble
        placement="top"
        title="Backward"
      >
        <Button
          textColor="text-current"
          icon={<BackOutlineIcon />}
          faded
          disabled={!canGoBack}
          onClick={goBack}
        />
      </TooltipBubble>
      <TooltipBubble
        placement="top"
        title="Forward"
      >
        <Button
          textColor="text-current"
          icon={<ForwardOutlineIcon />}
          faded
          disabled={!canGoForward}
          onClick={goForward}
        />
      </TooltipBubble>
    </div>
  );
};
